import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Politique de Confidentialité</h1>

        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300 mb-6">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Collecte des Informations</h2>
          <p className="text-gray-300 mb-4">
            Nous collectons les informations que vous nous fournissez directement lorsque vous :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Créez un compte</li>
            <li>Utilisez notre chatbot</li>
            <li>Contactez notre service client</li>
            <li>Vous abonnez à notre newsletter</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Utilisation des Données</h2>
          <p className="text-gray-300 mb-4">
            Nous utilisons les informations collectées pour :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Fournir et améliorer nos services</li>
            <li>Personnaliser votre expérience</li>
            <li>Communiquer avec vous</li>
            <li>Assurer la sécurité de nos services</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Protection des Données</h2>
          <p className="text-gray-300 mb-6">
            Nous mettons en place des mesures de sécurité appropriées pour protéger vos données personnelles contre tout accès, modification, divulgation ou destruction non autorisée.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Cookies et Technologies Similaires</h2>
          <p className="text-gray-300 mb-6">
            Nous utilisons des cookies et technologies similaires pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. Vous pouvez contrôler l'utilisation des cookies via les paramètres de votre navigateur.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Partage des Informations</h2>
          <p className="text-gray-300 mb-6">
            Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos informations avec des tiers uniquement dans les cas suivants :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Avec votre consentement</li>
            <li>Pour des raisons légales</li>
            <li>Avec nos prestataires de services</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Vos Droits</h2>
          <p className="text-gray-300 mb-4">
            Vous disposez des droits suivants concernant vos données personnelles :
          </p>
          <ul className="list-disc pl-6 text-gray-300 mb-6">
            <li>Droit d'accès</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
            <li>Droit d'opposition</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Contact</h2>
          <p className="text-gray-300 mb-6">
            Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, vous pouvez nous contacter à l'adresse suivante : privacy@botmaker-agency.com
          </p>
        </div>
      </div>
    </div>
  );
}